import React from "react";


export default function DashboardSkeleton() {
  return (
    <div
      className="
        mx-auto max-w-[1600px]
        px-4 py-5
        sm:px-6
        lg:p-8
      "
      data-testid="dashboard-skeleton"
    >
      <div
        className="
          animate-pulse
          space-y-5
        "
      >
        <div
          className="
            h-20 rounded-3xl
            bg-[var(--do-bg-2)]
          "
        />

        <div
          className="
            grid grid-cols-1
            gap-4
            sm:grid-cols-2
            xl:grid-cols-4
          "
        >
          {[1, 2, 3, 4].map(
            (item) => (
              <div
                key={item}
                className="
                  h-32 rounded-3xl
                  bg-[var(--do-bg-2)]
                "
              />
            )
          )}
        </div>

        <div
          className="
            grid grid-cols-1
            gap-4
            xl:grid-cols-2
          "
        >
          <div
            className="
              h-72 rounded-3xl
              bg-[var(--do-bg-2)]
            "
          />

          <div
            className="
              h-72 rounded-3xl
              bg-[var(--do-bg-2)]
            "
          />
        </div>
      </div>
    </div>
  );
}
